export default "__VITE_ASSET__1112f607__"